import styled from "styled-components";

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 910px) {
    margin: 0 auto;
    width: 85%;
  }
`;
